import store from "@/store";
import NgoInterfacesModule from "./store";
export default [
  {
    path: "/guest-pages-management",
    component: () => import("./moduleLayout.vue"),
    beforeEnter(to, _, next) {
      if (!store.hasModule("manageInterfaceNgo"))
        store.registerModule("manageInterfaceNgo", NgoInterfacesModule);
      next();
    },
    children: [
      {
        path: "about-ngo",
        name: "about-ngo",
        props: true,
        component: () => import("./pages/about-ngo/index.vue"),
        meta: {
          pageTitle: "لمحة عن المنظمة",
          slug: "ngo_about_ngo",
          instructionsSlug: "about-ngo-management",
          breadcrumb: [
            {
              text: "إدارة واجهات الجمهور ",
              active: true,
            },
            {
              text: "لمحة عن المنظمة ",
              active: true,
            },
          ],
        },
      },
      {
        path: "job-vacancies",
        name: "job-vacancies-management",
        props: true,
        component: () => import("./pages/jobs/index.vue"),
        meta: {
          pageTitle: "فرص العمل",
          slug: "opportunities",
          instructionsSlug: "jobs-management",
          breadcrumb: [
            {
              text: "إدارة واجهات الجمهور ",
              active: true,
            },
            {
              text: "فرص العمل ",
              active: true,
            },
          ],
        },
      },
      {
        path: "volunteer-vacancies",
        name: "volunteer-vacancies-management",
        props: true,
        component: () => import("./pages/jobs/index.vue"),
        meta: {
          pageTitle: "فرص التطوع",
          slug: "opportunities",
          instructionsSlug: "volunteer-management",
          // permissionSlug: "",
          breadcrumb: [
            {
              text: "إدارة واجهات الجمهور ",
              active: true,
            },
            {
              text: "فرص التطوع ",
              active: true,
            },
          ],
        },
      },
      {
        path: "edit-jobs/:id",
        name: "edit-jobs",
        props: true,
        component: () => import("./pages/add-jobs/index.vue"),
        meta: {
          pageTitle: "تعديل فرص العمل",
          slug: "opportunities",
          instructionsSlug: "job-opportunities",

          // permissionSlug: "job-opportunities",
          breadcrumb: [
            {
              text: "إدارة واجهات الجمهور ",
              active: true,
            },
            {
              text: "فرص العمل ",
              to: "/guest-pages-management/job-vacancies",
            },
            {
              text: "تعديل فرص العمل ",
              active: true,
            },
          ],
        },
      },
      {
        path: "add-jobs",
        name: "add-jobs",
        props: true,
        component: () => import("./pages/add-jobs/index.vue"),
        meta: {
          pageTitle: "إضافة فرص العمل",
          slug: "opportunities",
          instructionsSlug: "job-opportunities",
          breadcrumb: [
            {
              text: "إدارة واجهات الجمهور ",
              active: true,
            },
            {
              text: "فرص العمل ",
              to: "/guest-pages-management/job-vacancies",
            },
            {
              text: "إضافة فرص العمل ",
              active: true,
            },
          ],
        },
      },
      {
        path: "add-volunteer",
        name: "add-volunteer",
        props: true,
        component: () => import("./pages/add-jobs/index.vue"),
        meta: {
          pageTitle: "إضافة فرص التطوع",
          slug: "opportunities",
          instructionsSlug: "volunteer-opportunities",
          breadcrumb: [
            {
              text: "إدارة واجهات الجمهور ",
              active: true,
            },
            {
              text: "فرص التطوع ",
              to: "/guest-pages-management/volunteer-vacancies",
            },
            {
              text: "إضافة فرص التطوع ",
              active: true,
            },
          ],
        },
      },
      {
        path: "edit-volunteer/:id",
        name: "edit-volunteer",
        props: true,
        component: () => import("./pages/add-jobs/index.vue"),
        meta: {
          pageTitle: "تعديل فرص التطوع",
          slug: "opportunities",
          instructionsSlug: "volunteer-opportunities",
          breadcrumb: [
            {
              text: "إدارة واجهات الجمهور ",
              active: true,
            },
            {
              text: "فرص التطوع ",
              to: "/guest-pages-management/volunteer-vacancies",
            },
            {
              text: "تعديل فرص التطوع ",
              active: true,
            },
          ],
        },
      },
      {
        path: "campaigns",
        name: "campaigns-management",
        component: () => import("./pages/campaigns/index.vue"),
        meta: {
          pageTitle: "حملات التبرع",
          slug: "campaigns",
          instructionsSlug: "campaigns",

          breadcrumb: [
            {
              text: "إدارة واجهات الجمهور ",
              active: true,
            },
            {
              text: "حملات التبرع",
              active: true,
            },
          ],
        },
      },
      {
        path: "images-slider",
        name: "images-slider",
        component: () => import("./pages/images-slider/index.vue"),
        meta: {
          pageTitle: "معرض الصور",
          slug: "slide-images",
          instructionsSlug: "slide-images",
          breadcrumb: [
            {
              text: "إدارة واجهات الجمهور ",
              active: true,
            },
            {
              text: "معرض الصور",
              active: true,
            },
          ],
        },
      },
      {
        path: "events",
        name: "events-management",
        component: () => import("./pages/events/index.vue"),
        meta: {
          pageTitle: "الفعاليات",
          slug: "ngo-events",
          instructionsSlug: "events-activities",
          breadcrumb: [
            {
              text: "إدارة واجهات الجمهور ",
              active: true,
            },
            {
              text: "الفعاليات",
              active: true,
            },
          ],
        },
      },
      {
        path: "statistics",
        name: "statistics-management",
        component: () => import("./pages/statistics/index.vue"),
        meta: {
          pageTitle: "الإحصائيات",
          slug: "statistics",
          instructionsSlug: "statistics",
          breadcrumb: [
            {
              text: "إدارة واجهات الجمهور ",
              active: true,
            },
            {
              text: " الإحصائيات",
              active: true,
            },
          ],
        },
      },
      {
        path: "news-management",
        name: "news-management",
        component: () => import("./pages/news/index.vue"),
        meta: {
          pageTitle: "الأخبار",
          slug: "news",
          instructionsSlug: "news",
          breadcrumb: [
            {
              text: "إدارة واجهات الجمهور ",
              active: true,
            },
            {
              text: "الأخبار",
              active: true,
            },
          ],
        },
      },
      {
        path: "news-details/:id",
        name: "news-details",
        props: true,
        component: () => import("./pages/news-details/index.vue"),
        meta: {
          pageTitle: "تفاصيل الخبر",
          slug: "news",
          instructionsSlug: "news",
          breadcrumb: [
            {
              text: "إدارة واجهات الجمهور ",
              active: true,
            },
            {
              text: "الأخبار",
              to: "/guest-pages-management/news-management",
            },
            {
              text: " تفاصيل الخبر",
              active: true,
            },
          ],
        },
      },

      {
        path: "guests-messages",
        name: "guests-messages",
        component: () => import("./pages/contact-us-messages/index.vue"),
        meta: {
          pageTitle: "رسائل الجمهور",
          slug: "ngo_public_messages",
          instructionsSlug: "ngo_public_messages",
          breadcrumb: [
            {
              text: "إدارة واجهات الجمهور ",
              active: true,
            },
            {
              text: "رسائل الجمهور",
              active: true,
            },
          ],
        },
      },
      {
        path: "payment-management",
        name: "payment-management",
        component: () => import("./pages/payment-management/index.vue"),
        meta: {
          pageTitle: "إدارة التبرع الالكتروني",
          slug: "ngo_payments",
          instructionsSlug: "ngo_payments",
          breadcrumb: [
            {
              text: "إدارة واجهات الجمهور ",
              active: true,
            },
            {
              text: "إدارة التبرع الالكتروني",
              active: true,
            },
          ],
        },
      },
    ],
  },
];
